var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',_vm._g(_vm._b({attrs:{"visible":"","ok-only":""}},'b-modal',_vm.$props,false),_vm.$listeners),[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }